<script lang="ts">
	import Card from '@smui/card';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import TableLoading from '../../../..//shared/components/common/Loading/TableLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import CategoriaMisura from '../../../../shared/models/PSCL/Misura/CategoriaMisura';
	import TipoMisura from '../../../../shared/models/PSCL/Misura/TipoMisura';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = CategoriaMisura.get(params.id);
	let [dataTipiMisura, loadingTipiMisura, errorTipiMisura] = TipoMisura.getList({ categoriaMisuraId: Number(params.id) });

	function onSubmit() {
		[data, loading, error] = CategoriaMisura.save($data);
	}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.measure_category.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input label="{$_('page.measure_category.detail.code')}" bind:value="{$data.codice}" required class="md:col-start-2" />
			<Input label="{$_('page.measure_category.detail.description')}" bind:value="{$data.descrizione}" required class="md:col-start-2" />
		</form>
		{#if Number(params.id) > 0}
			<div class="pt-4">
				<Card class="px-8 py-8 pt-4" padded>
					<div class="flex justify-between">
						<Title title="{'Tipi misura'}" inCard="{true}" />
					</div>
					<br />
					{#if $loadingTipiMisura}
						<TableLoading />
					{:else if $dataTipiMisura.response && $dataTipiMisura.response.length > 0}
						<div class="flex flex-col">
							<div class="sm:-mx-6 lg:-mx-8 -my-2 overflow-x-auto">
								<div class="sm:px-6 lg:px-8 inline-block min-w-full py-2 align-middle">
									<div class="overflow-hidden">
										<table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
											<thead>
												<tr class="p-1">
													<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
														>{$_('page.measure_type.list.description')}</th
													>
													<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
														>{$_('page.measure_type.list.measure_category')}</th
													>
													<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
														>{$_('page.measure_type.list.axis')}</th
													>
													<th scope="col" class="relative border-b p-2.5 text-center text-xs leading-6 tracking-wider"
														>{$_('global.actions')}</th
													>
												</tr>
											</thead>
											<tbody>
												{#each $dataTipiMisura.response as row}
													<tr class="odd:bg-white even:bg-gray-50 p-1">
														<td class="border-b p-2.5 text-center leading-5">{row.nome}</td>
														<td class="border-b p-2.5 text-center leading-5">{row.categoriaMisura.descrizione ?? ''}</td>
														<td class="border-b p-2.5 text-center leading-5">{row.asse.descrizione ?? ''}</td>
														<td class="whitespace-nowrap border-b p-2.5 text-center leading-5">
															<div class="item-center flex justify-center">
																<div>
																	<a href="/#/tipomisura/{row.id}">
																		<button class="h-7.5 w-7.5">
																			<span class="material-icons-outlined text-base leading-[1.8rem]"
																				>launch</span
																			>
																		</button>
																	</a>
																</div>
															</div>
														</td>
													</tr>
												{/each}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					{:else}
						<span>{$_('page.measure_type.list.no_measure_types_found')}</span>
					{/if}
				</Card>
			</div>
		{/if}
	{/if}
</Card>
